import {config} from '../config';

export default {
    getMaxIntervalMinutes: () => config.data.dataCollection.maxIntervalMinutes,
    getMinIntervalMinutes: () => config.data.dataCollection.minIntervalMinutes,
    getStepMinutes: () => config.data.dataCollection.stepMinutes,
    getMinDelayMinutes: () => config.data.dataCollection.minDelayMinutes,
    getMaxDelayMinutes: () => config.data.dataCollection.maxDelayMinutes,
};
